module.exports = __webpack_public_path__ + "img/image-card-01.8f8745d8.png";